export function getBaseUrl(protocol?: string, hostname?: string, port?: number): string {
    return `${protocol || window.location.protocol}//${hostname || window.location.hostname}` + (port ? `:${port}` : '')
}

export const convertToNameFormat = (oldName: string): string => {
    if (!oldName) return ''

    // После пробела первая будет заглавная, остальные строчные
    let nameParts = oldName.split(/\s+/)
    nameParts = nameParts.map(part => {
        if (!part) return ''
        // Исключаем апострофы для случаев G‘ulomjon или О‘Коннор
        if (part.includes('\'') || part.includes('\‘')) return part[0]?.toUpperCase() + part?.substring(1)

        return part[0]?.toUpperCase() + part?.substring(1)?.toLowerCase()
    })

    let name = nameParts.join(' ')

    // После дефиса тоже будет заглавная
    nameParts = name.split('-')
    nameParts = nameParts.map(part => {
        if (!part) return ''
        return part[0]?.toUpperCase() + part?.substring(1)
    })

    return nameParts.join('-')
}
